import React, { Component } from 'react'
import Team from './Team'
import Games from './Games'
import GameForm from './GameForm'
import ControllerRoutes from '../Controller'
import * as adminRoutes from './routes'
import { Route } from 'react-router-dom'
import { Segment } from 'semantic-ui-react'

class Admin extends Component {
  render() {
    return (
      <Segment>
        <Route exact path={adminRoutes.TEAM} component={Team} />
        <Route exact path={adminRoutes.GAMES} component={Games} />
        <Route exact path={adminRoutes.GAMEFORM_NEW} component={GameForm} />
        <Route exact path={adminRoutes.GAMEFORM_EDIT} component={GameForm} />
        <ControllerRoutes />
      </Segment>
    )
  }
}

export default Admin



// WEBPACK FOOTER //
// ./src/components/Admin/index.jsx